import React, { useEffect, useState } from "react";
import YouTube from 'react-youtube';
import "../../../../styles/styles.css"


const PageSingleVideo = () => {
  const [isPlay, setIsPlay] = useState(false);
  const [isRendered, setIsRendered] = useState(false);

  useEffect(() => {
    setIsRendered(true);
  }, []);

  const opts = {
    width: '100%',
    height: '100%',
    playerVars: {
      autoplay: 1,
    }}
  const renderMainVideo = () => {
    return ( 
      <div style={{height:"85vh"}}>
          <YouTube style={{height: "100%", width: "100vw"}}
            className="bgColor" 
            opts={opts}
            videoId={window.location.pathname.replace("/video/","")} 
          />
      </div>
    );
  };

  return (

        <div className="bgColor fullVideo">
             {renderMainVideo()}
        </div>
      
  );
};

export default PageSingleVideo;
